import React from 'react';
import PropTypes from 'prop-types';
import { cx } from '@emotion/css';

import { abbreviateNumber, formatPercentage, thousandSeparator } from '@ajaibid/utils';
import {
  styOrderBookSectionContainer,
  styOrderBookColumn,
  styOrderBookItem,
  styOrderBookInfoContainer,
  styOrderBookInfoItem,
} from './styles';

const OrderBookInfoItems = [
  [
    { text: 'Open', name: 'open', value: (val) => thousandSeparator(val) },
    { text: 'High', name: 'high', value: (val) => thousandSeparator(val) },
    { text: 'Low', name: 'low', value: (val) => thousandSeparator(val) },
    { text: 'Foreign Buy', name: 'foreign_buy_value', value: (val) => abbreviateNumber(val) },
    { text: 'Foreign Sell', name: 'foreign_sell_value', value: (val) => abbreviateNumber(val) },
    { text: 'Turnover %', name: 'turnover_pct', value: (val) => formatPercentage(val) },
  ],
  [
    { text: 'Close', name: 'close', value: (val) => thousandSeparator(val) },
    { text: 'Volume', name: 'volume', value: (val) => abbreviateNumber(val) },
    { text: 'Mkt. Cap', name: 'market_cap', value: (val) => abbreviateNumber(val) },
    { text: '52 WK High', name: 'high_52_wk', value: (val) => thousandSeparator(val) },
    { text: '52 WK Low', name: 'low_52_wk', value: (val) => thousandSeparator(val) },
    { text: 'Tradeable', name: 'tradable_shares', value: (val) => abbreviateNumber(val) },
  ],
];

function OrderBookInfo({ tradeData }) {
  if (!tradeData) return null;

  return (
    <div className={cx(styOrderBookSectionContainer, styOrderBookInfoContainer)}>
      {OrderBookInfoItems.map((item, index) => (
        <div className={styOrderBookColumn} key={index}>
          {item.map((subItem, subIndex) => (
            <div className={cx(styOrderBookItem, styOrderBookInfoItem)} key={subIndex}>
              <span>{subItem.text}</span>
              <span className="item-value">{subItem.value(tradeData[subItem.name])}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

OrderBookInfo.propTypes = {
  tradeData: PropTypes.object,
};

OrderBookInfo.defaultProps = {
  tradeData: null,
};

export default OrderBookInfo;
